import { tippyAlert } from 'Functions/tippy';
import Swal from 'sweetalert2';

window.Eshop.confirm = function(text, options, callback, thenCallback = null) {
    var settings = $.extend({
        title: text,
        denyButtonText: options.cancelButtonText || 'Zrušiť',
        confirmButtonText: options.confirmButtonText || 'Ok',
        buttonsStyling: false,
        showDenyButton: true,
        reverseButtons: true,
        icon: 'question',
        customClass: {
            confirmButton: 'c-btn c-btn--delete',
            denyButton: 'c-btn c-btn--light-grey'
        },
        preConfirm: () => {
            return callback()
        }
    }, options);

    Swal.fire(settings).then(thenCallback);
}

window.Eshop.tippyAlert = tippyAlert
